import { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { useModal } from 'hooks';
import { useConfirm, useRegister } from "api/auth";

import ModalTemplate from "../components/ModalTemplate";
import FormCreateUsername from "../components/FormCreateUsername";
import Congrats from "../components/Congrats";
import FormCreatePassword from "../components/FormCreatePassword";
import FormPhoneNumber from "../components/FormPhoneNumber";
import FormCode from "../components/FormCode";
import useSession from "hooks/useSession";
import useSteps from "hooks/useSteps";
import { parsePhoneNumber } from "libphonenumber-js";


const Register = () => {

  const { t } = useTranslation()
  const { Modal: ModalWelcome } = useModal('welcome')

  const {
    register,
    isLoading: isRegisterLoading,
    isSuccess: isRegisterSuccess,
    error: registerError,
  } = useRegister()

  const {
    confirm,
    isLoading: isConfirmLoading,
    isSuccess: isConfirmSuccess,
    error: confirmError,
  } = useConfirm()

  const { login } = useSession()

  const { step, nextStep, prevStep } = useSteps()

  const [email, setEmail] = useState('')
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [country, setCountry] = useState()
  const [mobileNumber, setMobileNumber] = useState('')
  const [code, setCode] = useState('')


  const handleRegister = ({ mobileNumber }) => {
    register({
      email,
      nickname: username,
      password,
      mobileNumber,
    })
  }

  const handleConfirm = ({ code }) => confirm({ email, code })


  useEffect(() => {
    if (isRegisterSuccess) nextStep()
  }, [isRegisterSuccess])

  useEffect(() => {
    if (isConfirmSuccess) {
      nextStep()
      login({ email, password })
    }
  }, [isConfirmSuccess])


  if (step === 0) return (
    <ModalTemplate
      flowTitle={t('createAccount')}
      currentStep={1}
      totalSteps={4}
      onBack={ModalWelcome.open}
    >
      <FormCreateUsername
        email={email}
        setEmail={setEmail}
        username={username}
        setUsername={setUsername}
        onSuccess={nextStep}
      />
    </ModalTemplate>
  )


  if (step === 1) return (
    <ModalTemplate
      flowTitle={t('createAccount')}
      currentStep={2}
      totalSteps={4}
      onBack={prevStep}
    >
      <FormCreatePassword
        password={password}
        setPassword={setPassword}
        confirmPassword={confirmPassword}
        setConfirmPassword={setConfirmPassword}
        onSuccess={nextStep}
      />
    </ModalTemplate>
  )


  if (step === 2) return (
    <ModalTemplate
      flowTitle={t('createAccount')}
      currentStep={3}
      totalSteps={4}
      onBack={prevStep}
    >
      <FormPhoneNumber
        title={t('enterYourMobileNumber')}
        country={country}
        setCountry={setCountry}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        showInfo
        onSubmit={handleRegister}
        isLoading={isRegisterLoading}
        error={registerError && t('mobileNumberRegistered')}
      />
    </ModalTemplate>
  )


  if (step === 3) {
    const countryCode = country.value
    const newNumber = parsePhoneNumber(`${countryCode}${mobileNumber}`)
    const mobileNumberText = newNumber?.formatInternational()

    return (
      <ModalTemplate
        flowTitle={t('createAccount')}
        currentStep={4}
        totalSteps={4}
        onBack={prevStep}
      >
        <FormCode
          code={code}
          title={t('enterCodeSentTo', { mobileNumber: mobileNumberText })}
          setCode={setCode}
          onSubmit={handleConfirm}
          isLoading={isConfirmLoading}
          error={confirmError && t('codeInvalid')}
          textCTA={isConfirmLoading
            ? t('creatingAccount')
            : t('createAccount')
          }
        />
      </ModalTemplate>
    )
  }


  if (step === 4) return (
    <Congrats
      title={t('congratsHaveCreatedAnAccount')}
      description={t('nowYouAreFlixxer')}
    />
  )
}

export default Register